interface ColorProfile {
  light: string
  main: string
  dark: string
  '50'?: string
  '100'?: string
  '200'?: string
  '300'?: string
  '400'?: string
  '500'?: string
  '600'?: string
  '700'?: string
  '800'?: string
  '900'?: string
  A50?: string
  A100?: string
  A200?: string
  A300?: string
  A400?: string
  A500?: string
  A600?: string
  A700?: string
  A800?: string
  A900?: string
  contrastText?: string
}

export const magenta: ColorProfile = {
  light: '#e20074',
  dark: '#b72363',
  main: '#f0a8cd',
}

export const grey: ColorProfile = {
  light: '#646464',
  dark: '#b1b0b0',
  main: '#e8e8e8',
  A50: '#e3e3e3',
}

export const black: ColorProfile = {
  light: '#000',
  main: '',
  dark: '',
}

export const white: ColorProfile = {
  light: '#fff',
  dark: '',
  main: '',
}
